
// --- tipi dei subStep ---

export type DocumentSubStep = {
  id: number;
  value: string;
  label: string;
  completed: boolean;
  required: boolean;
  documents: { id: number; key: string; label: string }[]; // es. mini-wizard
};

export type FormSubStep = {
  id: number;
  value: string;       // chiave per render
  label: string;
  completed: boolean;
  required: boolean;
  type: 'form' | 'dialog';        // per distinguerlo dai documenti
};

export type SubStep = DocumentSubStep | FormSubStep;

// tipo dell'item contact
export type ContactItem = {
  id: number;
  value: string;
  label: string;
  type: 'contact';
  imageDesk: string;
  imageMob: string;
  subSteps?: SubStep[];
};


export type Option = {
  id: number
  value: string
  label: string
  imageDesk: string
  imageMob: string
}

export type AnagraficaSubStep = {
  id: number
  key: string
  label: string
  type: string
  rhfFields: string[]
  conditional?: {
    whenValueIs: string
    requiredFields: string[]
  }[]
  clearOnChange?: string[]
}

export type DataBlock =
  | { cittadinanza: Option[] }
  | { CitizenshipType: Option[] }
  | { statocivile: Option[] }
  | { tipoabitazione: Option[] }
  | { tipodocumento: Option[] }
  | { recuperadati: Option[] }
  | { anagraficaSubSteps: AnagraficaSubStep[] }

// tipo dell'intero infoStruct
export type InfoStruct = {
  contact: ContactItem[];
 data: DataBlock[]
  profession: any[];
  services: any[];
  summary: any[];
};



// store.ts (continua)
import { atom } from "jotai";
import { infoStruct as initialInfoStruct } from "./incfostruct";

export const infoStructAtom = atom<InfoStruct>(initialInfoStruct);


export const selectedStepAtom = atom<number>(1);

// SubStep selezionato
export const selectedSubStepAtom = atom<number | null>(null);

// InnerStep selezionato
export const selectedInnerStepAtom = atom<number | null>(null);


export const wizardAtom = atom({
  step: 0,                // L'indice 0-4 degli STEPS (Contatti, Dati, etc.)
  selectedOptionId: null, // L'ID della scelta (es: 1, 2 o 3 di contact)
  isInnerView: false,     // Se l'utente è "dentro" i subSteps
  data: {}   ,             // Qui salverai i dati raccolti
  innerStepIndex: 0,      // Indice del subStep corrente (Carta d’identità, Codice fiscale, ecc.)
  documentIndex: 0,       // Indice del documento corrente (Select, Upload, Success)
});

export const currentStepIndexAtom = atom(0); // Da 0 a 4 (i tuoi 5 steps)
export const selectedOptionIdAtom = atom<number | null>(null); // L'id dell'opzione (1, 2 o 3)
export const isInnerViewAtom = atom(false); // true se l'utente è dentro i subSteps


// Documento attualmente selezionato nel mini-wizard
export const activeDocumentAtom = atom<string | null>(null);

// Indice del sub-step corrente
export const documentSubStepIndexAtom = atom<number>(0);

export const goBackAtom = atom<() => void>(() => {});

export const uploadedDocumentsAtom = atom<string[]>([]); // lista dei documenti caricati */

export const activeSubStepIdAtom = atom<number | null>(null) ///stpe attivo all'interno del flow


//Step interno del documento
export const documentStepIndexAtom = atom(0)

//Progresso per ogni substep
export type DocumentProgress = {
  stepIndex: number
  completed: boolean
  submitting?: boolean
  error?: string | null
  ocrOk?: boolean | undefined
  errorTitle?:string | null
}

export const documentProgressAtom = atom<Record<number, DocumentProgress>>({})
export const optionalInfoShownAtom = atom(false)

export const documentNextAtom = atom(0)

export type Side = 'front' | 'back' | 'success'
export type Mode = 'insert' | 'preview'

export const documentModeAtom = atom<Mode>('insert')

export const currentSideAtom = atom<Side>('front')

export const docAdvanceAtom = atom(0)


export type ContactReturnPoint = {
  selectedValue: string
  selectedSubStep: string | null
} | null

export const contactReturnPointAtom = atom<ContactReturnPoint>(null)

//stepper DATI ANAGRAFICA 
export const anagraficaSubStepAtom = atom<number>(0)

export const footerNextAtom = atom<null | (() => Promise<boolean>)>(null)

// Sentence shown in the footer on the Services step (e.g. SECCI / Set Informativo)
export const footerServiceSentenceAtom = atom<string>('')

// radio values (atoms)
export const citizenshipAtom = atom<string>('')        // Citizenship
export const maritalStateAtom = atom<string>('')       // MaritalState
export const citizenshipTypeAtom = atom<string>('')  
export const homeTypeAtom = atom<string>('')          // HomeType
export const documentTypeAtom = atom<string>('')       // Document.DocumentType

/////---------------------------------------

///HISTORY PER NAVIGAZIONE SUBSTEPS
export const contactReturnSubStepAtom = atom<string | null>(null)

export const lastContactSubStepAtom = atom<string | null>(null)
export const lastServicesSubStepAtom = atom<string | null>(null)
/** Shown once immediately after the user removes insurance via the confirm modal. */
export const insuranceRemovedPageAtom = atom<boolean>(false)


///OTP CHOOSE 
export const otpChoiceAtom = atom<string>('') // '' | 'OTP' | 'NOOTP'

// ── Profession Step ───────────────────────────────────────────────────────────
export const professionSubStepAtom = atom<number>(0)      // current sub-step index (mirrors anagraficaSubStepAtom)
export const professionActivityAtom = atom<string>('')    // e.g. 'D' | 'T' | 'A' | 'P' | 'X'
export const professionOccupationAtom = atom<string>('')  // e.g. 'NE' | 'PR' | 'TA' | …
export const professionMensilitaAtom = atom<string>('')   // '12' | '13' | '14'
export const professionPepAtom = atom<boolean>(false) // false = NO (default), true = SI